<script scoped>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        persentase_bawah: 0,
        persentase_atas: 0,
        keterangan: "",
        idtreshold_analisa_soal: null,
      },
    };
  },
  props: ["typeTrans", "dataTresholdAnalisa"],
  watch: {
    dataTresholdAnalisa: function (newVal) {
      if (newVal == null) {
        this.formData = {
          persentase_bawah: 0,
          persentase_atas: 0,
          keterangan: "",
          idtreshold_analisa_soal: null,
        };
      } else {
        this.formData = {
          persentase_bawah: newVal.persentase_bawah,
          persentase_atas: newVal.persentase_atas,
          keterangan: newVal.keterangan,
          idtreshold_analisa_soal: newVal.idtreshold_analisa_soal,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/treshold-analisa-soal"
          : `master/treshold-analisa-soal/${this.formData.idtreshold_analisa_soal}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (
        this.formData.persentase_atas === "" ||
        this.formData.persentase_bawah === "" ||
        !this.formData.keterangan
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="persentase_bawah" class="form-label">Pesentase Bawah</label>
        <input
          type="number"
          v-model="formData.persentase_bawah"
          class="form-control"
          id="persentase_bawah"
          placeholder="Pesentase Bawah..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="persentase_atas" class="form-label">Persentase Atas</label>
        <input
          type="number"
          v-model="formData.persentase_atas"
          class="form-control"
          id="persentase_atas"
          placeholder="Persentase Atas..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="Keterangan" class="form-label">Keterangan</label>
        <input
          v-model="formData.keterangan"
          class="form-control"
          id="Keterangan"
          placeholder="Keterangan..."
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
